import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { MatAutocompleteTrigger } from '@angular/material/autocomplete'
import { TranslationService } from '../../../services/translation.service'
import { GhsSelectComponent } from './ghs-select/ghs-select.component'
import { MatIcon } from '@angular/material/icon'
import { MatButton } from '@angular/material/button'
import {
  GhsClassification,
  GhsClassificationFormData,
} from '../../../types/ghs'

@Component({
  selector: 'app-product-ghs-form',
  imports: [GhsSelectComponent, MatIcon, MatButton],
  templateUrl: './product-ghs-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product-ghs-form.component.scss',
})
export class ProductGhsFormComponent implements OnChanges {
  protected translationService = inject(TranslationService)

  @Input() clonedData?: GhsClassificationFormData
  @Output() formChanged = new EventEmitter<GhsClassificationFormData>()
  @Output() backPressed = new EventEmitter()
  @ViewChild(MatAutocompleteTrigger) autocomplete!: MatAutocompleteTrigger

  selected: Array<GhsClassification> = []

  ngOnChanges(changes: SimpleChanges) {
    if (changes['clonedData'] && changes['clonedData'].currentValue) {
      this.selected = changes['clonedData'].currentValue.ghsClassifications
    }
  }

  /**
   * Handles the change of selected ghs classifications
   * @param classifications
   */
  handleChange(classifications: Array<GhsClassification>) {
    this.selected = classifications
  }

  /**
   * Handle the completion of form component
   */
  onSubmit() {
    this.formChanged.emit({
      formName: 'ghsClassificationForm',
      ghsClassifications: this.selected,
    })
  }

  onReset() {
    this.selected = []
  }

  /**
   * Handles the click of the back button to navigate to previous form
   */
  goBack() {
    this.backPressed.emit(null)
  }
}
